import { WithdrawDialogContentContainer } from './WithdrawDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { SparkLendToken } from '@/features/sparklend/tokens/SparkLendToken'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export interface WithdrawDialogProps extends CommonDialogProps {
  token: SparkLendToken
}

function WithdrawDialog({ token, open, setOpen }: WithdrawDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <WithdrawDialogContentContainer token={token} closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const withdrawDialogConfig: DialogConfig<WithdrawDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: WithdrawDialog,
  name: 'WithdrawDialog',
}
